import { render, staticRenderFns } from "./TaskMedicationsForm.vue?vue&type=template&id=c4cf5a6c&lang=pug"
import script from "./TaskMedicationsForm.vue?vue&type=script&lang=js"
export * from "./TaskMedicationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports